import {defaultSelectedTipoListaChequeo} from './state';
import {filtro} from '../tipoSeguimiento/state';

export function setListarTipoListaChequeo(state, tipoListaChequeo) {
    state.tipoListaChequeo = tipoListaChequeo;
}

export function setTipoListaChequeo(state, tipoListaChequeo) {
    const tipos_seguimiento = [];

    tipoListaChequeo.tipo_seguimiento.map(ts => {
        if (!tipos_seguimiento.includes(ts.id)) {
            tipos_seguimiento.push(ts.id);
        }
    });

    state.selectedTipoListaChequeo.id = tipoListaChequeo.id;
    state.selectedTipoListaChequeo.tipo_lista = tipoListaChequeo.tipo_lista;
    state.selectedTipoListaChequeo.tipo_seguimiento = tipos_seguimiento;

    state.temporalSeguimientoSeleccionados = tipoListaChequeo.items;
}

export function setFiltro(state, buscar) {
    state.filtro = buscar;
}

export function setAccion(state, action) {
    state.accion = action;
}

export function setListarTipoSeguimiento(state, tipoSeguimientos) {
    state.tipoSeguimiento = tipoSeguimientos;
}

export function setTipoSeguimiento(state, tipoSeguimientos) {
    state.selectedTipoListaChequeo.tipo_seguimiento = tipoSeguimientos.map(p => {
        return {value: p.id, label: p.nombre};
    });

    state.selectedTipoListaChequeo.indices = tipoSeguimientos.map(p => {
        return {value: p.id, label: p.nombre};
    });
}

export function setPage(state, page) {
    state.filtro.page = page;
}

export function resetSelectedTipoListaChequeo(state) {
    Object.assign(state.selectedTipoListaChequeo, defaultSelectedTipoListaChequeo());
    state.tiposSeguimientoSeleccionados = [];
}

/**
 * Limpiar filtros del buscador de tipo de lista de chequeos.
 */
export function resetFilters(state) {
    Object.assign(state.filtro, filtro());
}

/**
 * Establecer un valor para tiposSeguimientoSeleccionados
 */
export function establecerTiposSeguimientoSeleccionados(state, tiposSeguimientoSeleccionados) {
    state.tiposSeguimientoSeleccionados = tiposSeguimientoSeleccionados;
}

/**
 * Establecer los items para los tipos de seguimiento seleccionados
 */
export function establecerItems(state, items) {

    let tiposSeguimientoSeleccionados = JSON.parse(JSON.stringify(state.tiposSeguimientoSeleccionados));

    tiposSeguimientoSeleccionados.map(ts => {
        items.map(i => {
            if (i.id_tipo_seguimiento === ts.id) {
                const item = ts.items.find(it => it.id === i.id);
                if (!item) {
                    i.seleccionado = false;
                    ts.items.push(i);
                }
            }
        });
    });

    state.tiposSeguimientoSeleccionados = tiposSeguimientoSeleccionados;
}

/**
 * Establecer items para la lista seleccionada
 */
export function establecerItemsLista(state, items) {
    state.selectedTipoListaChequeo.items = items;
}

/**
 * Establecer items para la lista seleccionada
 */
export function establecerItemsSeleccionados(state) {

    let tiposSeguimientoSeleccionados = JSON.parse(JSON.stringify(state.tiposSeguimientoSeleccionados));

    tiposSeguimientoSeleccionados.map(ts => {
        ts.items.map(i => {
            let seleccionado = false;
            state.temporalSeguimientoSeleccionados.map(tss => {
                if (!seleccionado && tss.id === i.id) {
                    seleccionado = true;
                }
            });
            i.seleccionado = seleccionado;
        });
    });

    state.tiposSeguimientoSeleccionados = tiposSeguimientoSeleccionados;
}

/**
 * Establece un valor para state.modal_empresas.ver
 */
export function setModalEmpresasVer(state, ver) {
    state.modal_empresas.ver = ver;
}

/**
 * Establece un valor para state.empresas
 */
export function setEmpresas(state, empresas) {
    state.empresas = empresas;
    state.empresas_filtradas = empresas;
}

/**
 * Establece un valor para state.empresas_filtradas
 */
export function setEmpresasFiltradas(state, empresas_filtradas) {
    state.empresas_filtradas = empresas_filtradas;
}

/**
 * Establece un valor para state.empresas_filtradas
 */
export function setEmpresasAsignadas(state) {
    state.empresas.map(empresa => {
        empresa.asignado = !!state.selectedTipoListaChequeo.empresas.find(e => e.id === empresa.id);
    });
}

export function setTipoListaChequeoLocal(state, tipoListaChequeo) {
    state.selectedTipoListaChequeo = tipoListaChequeo;
}

export function asignarEmpresa(state, id_empresa) {
    let empresa = state.empresas.find(e => e.id === id_empresa);

    if (empresa) {
        state.selectedTipoListaChequeo.empresas.push(empresa);
    }
}

export function desasignarEmpresa(state, id_empresa) {
    let indice = state.selectedTipoListaChequeo.empresas.findIndex(e => e.id === id_empresa);

    if (indice >= 0) {
        state.selectedTipoListaChequeo.empresas.splice(id_empresa, 1);
    }
}

/**
 * Establecer los nuevos tipos de listas de checqueo.
 * 
 * @param {*} state 
 * @param {*} newTypes 
 * @author Fernando Claros
 */
export function setTypesSelectedTracking(state, newTypes) {
    state.tiposSeguimientoSeleccionados = newTypes;
}

/**
 * Establecer el nuevo valor para: Control de los collapse (contenido) para la Vista previa.
 * @param {*} state 
 * @param {*} newCollapse 
 * @author Fernando Claros
 */
export function setCollapseViewer(state, newCollapse) {
    state.collapseViewer = newCollapse;
}



